let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cjdCl")).then(() => parcelRequire('egKJ5'));